/**
 * Amazon Pay表示制御ユーティリティ
 *
 * 本番環境ではAmazon Payを非表示にし、Kishユーザーのみテスト可能にする
 *
 * 表示条件:
 * 1. 環境変数 NEXT_PUBLIC_ENABLE_AMAZON_PAY が 'true'
 * OR
 * 2. currentUser.role === 'kish'
 */

/**
 * Amazon Payを表示すべきかどうかを判定
 * @param userRole ユーザーのrole (未ログインの場合はundefined)
 * @returns Amazon Payを表示すべきかどうか
 */
export const isAmazonPayEnabled = (userRole?: string | null): boolean => {
  // 環境変数でAmazon Payが有効化されている場合
  if (process.env.NEXT_PUBLIC_ENABLE_AMAZON_PAY === 'true') {
    return true
  }

  // Kishユーザーの場合（本番テスト用）
  if (userRole === 'kish') {
    return true
  }

  return false
}
